import { requestAnonymousSmallFileUploadUrlV2 } from "../api";
import { AnonymousHolterUploader } from "./AnonymousHolterUploader";

const resolveFilename = (file: Blob, filename?: string) => {
  if (filename) {
    return filename;
  }

  const namedFile = file as Blob & { name?: unknown };

  if (typeof namedFile.name === "string") {
    return namedFile.name;
  }

  throw new Error("filename is required for small anonymous file upload");
};

export class SmallFileHolterUploader extends AnonymousHolterUploader {
  async upload() {
    const filename = resolveFilename(this.options.file, this.options.filename);
    const response = await requestAnonymousSmallFileUploadUrlV2({
      serialNumber: this.options.serialNumber,
      sharableCode: this.options.sharableCode,
      measurementId: this.options.measurementId,
      filename,
    });
    const data = response?.data;

    if (!data) {
      throw new Error("Could not request small anonymous file upload URL");
    }

    if (!data?.upload_url) {
      throw new Error("Small anonymous file upload URL is missing");
    }

    await this.uploadWithRetry(async () => {
      const response = await fetch(data.upload_url, {
        method: "PUT",
        headers: data.headers ?? {},
        body: this.options.file,
      });

      if (!response.ok) {
        throw new Error(`Small anonymous file upload failed with status ${response.status}`);
      }

      return response;
    });

    this.options.onProgress?.(100);

    return data;
  }
}
